import { render, staticRenderFns } from "./EditMemory.vue?vue&type=template&id=6ec5e32a&scoped=true&"
import script from "./EditMemory.vue?vue&type=script&lang=js&"
export * from "./EditMemory.vue?vue&type=script&lang=js&"
import style0 from "./EditMemory.vue?vue&type=style&index=0&id=6ec5e32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5e32a",
  null
  
)

export default component.exports